var angular = require('angular');
var app = angular.module('learn-directives');

import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ChakraProvider } from '@chakra-ui/react';
import AppAnnouncementBanner from '../../app-announcement-banner/app-announcement-banner';
import React from 'react';
import { createRoot } from 'react-dom/client';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: false,
      refetchOnWindowFocus: false,
    },
  },
});

const bannerProps = {
  apiUrl: null,
  authToken: null,
  route: null,
  languageCode: null,
};

function renderBanner(root) {
  root.render(
    <QueryClientProvider client={queryClient}>
      <ChakraProvider>
        <AppAnnouncementBanner {...bannerProps} />
      </ChakraProvider>
    </QueryClientProvider>
  );
}

const reactDirective = app.directive('appAnnouncementBannerDirective', [
  'Application',
  'Authorization',
  '$location',
  '$translate',
  function (Application, Authorization, $location, $translate) {
    return {
      template:
        '<div id="app-announcement-banner-app" class="react-part"></div>',
      scope: {},
      link: function (scope, el, attrs) {
        const container = document.getElementById(
          'app-announcement-banner-app'
        );
        const root = createRoot(container);

        const tokenRecord = Authorization.getAuthToken();

        bannerProps.apiUrl = Application.API;
        bannerProps.authToken = tokenRecord.authtoken;
        bannerProps.route = $location.path();
        bannerProps.languageCode = $translate.use() || null;

        renderBanner(root);

        // Re-render when route changes
        scope.$watch(
          function () {
            return $location.path();
          },
          function (newPath, oldPath) {
            if (newPath !== oldPath) {
              bannerProps.route = newPath;
              renderBanner(root);
            }
          }
        );

        // Re-render when language changes
        scope.$watch(
          function () {
            return $translate.use();
          },
          function (newLang, oldLang) {
            if (newLang !== oldLang && newLang) {
              bannerProps.languageCode = newLang;
              renderBanner(root);
            }
          }
        );
      },
    };
  },
]);

export default reactDirective;
